// src/contexts/EstadoAppContext.jsx
import React, { createContext, useState, useContext } from 'react';

// 1. Crear el Contexto
export const EstadoAppContext = createContext();

// 2. Crear el Provider
export const EstadoAppProvider = ({ children }) => {
	const [estadoAppX, setEstadoAppX] = useState('inicial'); // Estado inicial por defecto
	const [selectedObra, setSelectedObra] = useState(null); // Estado para almacenar la obra seleccionada
	const [origenNavegacion, setOrigenNavegacion] = useState(null);
	const [idEtapa1, setIdEtapa1] = useState(null); // ID del expediente Etapa I para Etapa II
	console.log("ESTADO APP X---->", estadoAppX)

	// Función para cambiar el estado
	//nuevo estado para previewViabilidadTécnica
	//nuevo estado para previewInformeTecnicoObservaciones
	const cambiarEstadoApp = (nuevoEstado, opciones = {}) => {
		// Opciones puede contener { obra, origen }
		const { obra, origen } = opciones || {};		

		if (['inicial',
			'nuevo',
			'nuevo_etapa2',
			'ediT',
			'edit_etapa2',
			'edit_desde_pagos',
			'edit_desde_proyectos',
			'previewViabilidadTécnica',
			'previewInformeTecnicoObservaciones'].includes(nuevoEstado)) {
			setEstadoAppX(nuevoEstado);
			if (obra) {
				setSelectedObra(obra);
			}
			if (origen) {
				setOrigenNavegacion(origen);
			}
		} else {
			console.warn(`Estado no válido: ${nuevoEstado}. Los estados permitidos son 'inicial', 'nuevo', 'nuevo_etapa2', 'ediT', 'edit_desde_pagos', 'edit_desde_proyectos', 'previewViabilidadTécnica', 'previewInformeTecnicoObservaciones'.`);
		}
	};

	const contextValue = {
		estadoAppX,
		cambiarEstadoApp,
		selectedObra,
		origenNavegacion,
		setOrigenNavegacion,
		idEtapa1,
		setIdEtapa1
	};

	return (
		<EstadoAppContext.Provider value={contextValue}>
			{children}
		</EstadoAppContext.Provider>
	);
};

// 3. Crear un Custom Hook para facilitar el consumo
export const useEstadoApp = () => {
	const context = useContext(EstadoAppContext);
	if (context === undefined) {
		throw new Error('useEstadoApp debe ser usado dentro de un EstadoAppProvider');
	}
	return context;
};